<template>
	<div id="userinfo">
		<div style="height: 50px;background-color: seagreen;text-align: center;line-height: 50px;color: aliceblue;font-weight: bolder;font-size: 28px;">下载国度后台管理系统</div>
		<leftinfo></leftinfo>
		<router-view></router-view>
	</div>
</template>

<script>
	import leftinfo from './child/leftinfo'
	
	import {mapGetters} from 'vuex'
	
	export default{
		name:'userinfo',
		data(){
			return{

			}
		},
		created() {
			if(window.location.pathname != "/User/create"){
				this.$router.push("/User/create")
			}
		},
		computed:{
			...mapGetters(['showuser']),
		},
		mounted() {
			if(this.showuser != null){
				document.title = "下载国度后台管理系统"
			}else{
				this.$router.push('/login')
			}
		},
		components:{
			leftinfo
		},
		methods:{
		}
	}
</script>

<style scoped>
 #userinfo{
	 height: 100vh;
	 overflow: hidden;
 }
</style>